import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {TableComponent} from '@aviary/components/table/table.component';
import {TableDefinition} from '@store/aviary/aviary.adapter';
import {
  CatalogRecordAvailabilityBranch,
  CIRCULATION_ITEM_STATUS_CHIP_COLORS,
  CirculationItem,
  DISPLAYABLE_CIRCULATION_ITEM_STATUSES
} from '@store/catalog/catalog.types';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {CombinedCopyDetailsComponent} from '@app/catalog/bib-details/table-column-components/combined-copy-details.component';

@Component({
  selector: 'px-branch-availability-expansion',
  template: `
    @if (tableDefinition) {
      <div class="w-full ps-7 pe-5 -mt-6">
        <mx-table [tableDefinition]="tableDefinition"/>
      </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TableComponent]
})
export class BranchAvailabilityExpansionComponent {
  public _branch: CatalogRecordAvailabilityBranch;
  public tableDefinition: TableDefinition<CirculationItem, typeof CatalogSelectors.Availability>;

  @Input({required: true})
  public get row(): CatalogRecordAvailabilityBranch {
    return this._branch;
  }

  public set row(branch: CatalogRecordAvailabilityBranch) {
    this._branch = branch;
    this.tableDefinition = {
      defaultSelectorContainer: CatalogSelectors.Availability,
      dataSource: CatalogSelectors.Availability.branchCirculationItemsFor(this._branch),
      responsiveColumnsDefinition: {
        columnNamesSm: ['combinedCopyInfo', 'itemStatusSm'],
        columnNamesMd: ['itemCollectionName', 'itemCallNumber', 'itemShelfName', 'itemStatus'],
        columnNamesLg: ['itemCollectionName', 'itemCallNumber', 'itemShelfName', 'itemStatus']
      },
      includePaginationControls: false,
      showBottomBorder: true,
      noDataRowMessage: 'No copies available',
      columns: [
        {
          type: 'text',
          value: 'itemCollectionNameFor',
          header: 'Collection',
          truncate: true
        },
        {
          type: 'text',
          value: 'itemCallNumberFor',
          header: 'Call Number',
          truncate: true
        },
        {
          type: 'text',
          value: 'itemShelfNameFor',
          header: 'Shelf Location',
          truncate: true
        },
        {
          type: 'component',
          columnName: 'combinedCopyInfo',
          header: 'Details',
          componentClass: CombinedCopyDetailsComponent,
          componentProperties: {
            collection: 'itemCollectionNameFor',
            callNumber: 'itemCallNumberFor',
            shelfName: 'itemShelfNameFor'
          },
          headerCssClasses: 'w-full text-label-large',
        },
        {
          type: 'statusChip',
          header: 'Status',
          value: 'itemStatusFor',
          statusChipColors: CIRCULATION_ITEM_STATUS_CHIP_COLORS,
          displayableStatusNames: DISPLAYABLE_CIRCULATION_ITEM_STATUSES,
          headerCssClasses: 'w-[9.75rem]',
        },
        {
          type: 'statusChip',
          header: ' ',
          overrideColumnName: 'itemStatusSm',
          value: 'itemStatusFor',
          headerCssClasses: 'w-[9.5rem] grow',
          statusChipColors: CIRCULATION_ITEM_STATUS_CHIP_COLORS,
          displayableStatusNames: DISPLAYABLE_CIRCULATION_ITEM_STATUSES,
        }
      ]
    };
  }
}
